import React from "react";
import logo from "logo.png";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import URLSearchParams from "@ungap/url-search-params";
import { addUser } from "store/actions/security";

import "moment/locale/fr";

class Home extends React.Component {
  constructor(props) {
    super(props);

    const { history } = this.props;

    let { confirmation_token, recover_token, apiKey } = this.props.match.params;
    const params = new URLSearchParams(this.props.location.search);
    confirmation_token = confirmation_token || params.get("confirmation_token");
    recover_token = recover_token || params.get("recover_token");
    apiKey = apiKey || params.get("apiKey");

    // if (params.has("recover_token")) {
    //   redirectPath = `/resetting/reset/${params.get("recover_token")}`;
    // } else if (params.has("confirmation_token")) {
    //   redirectPath = `/registration/confirm/${params.get(
    //     "confirmation_token"
    //   )}`;
    // } else if (params.has("apiKey")) {
    //   redirectPath = null;
    //   apiKey = params.get("apiKey");
    // } else if (params.has("licence")) {
    //   redirectPath = null;
    //   licence = params.get("licence");
    // }

    if (confirmation_token) {
      history.push(`/registration/confirm/${confirmation_token}`);
    } else if (recover_token) {
      history.push(`/resetting/reset/${recover_token}`);
    } else if (apiKey) {
      // history.push(`/resetting/reset/${recover_token}`);
    } else {
      if (props.isAuth) {
        history.push("/signin");
      } else {
        history.push("/publications");
      }
    }
  }

  render() {
    // const { error } = this.state;
    const { isAuth } = this.props;

    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo img img-fluid" alt="logo" />
          <div className="d-flex flex-column  my-3">
            {/* {error && (
              <div className="text-danger text-center h3">
                {error ||
                  "Vous ne disposez pas des permissions pour accéder au kiosque"}
              </div>
            )} */}
          </div>
          {isAuth && (
            <React.Fragment>
              <p className="h3">
                Bienvenue sur le kiosque presse numérique offert par{" "}
                {process.env.REACT_APP_KIOSK_NAME}
              </p>

              <Link
                color="inherit"
                underline="none"
                className="App-link h4"
                to="/publications"
                href="/publications"
                rel="noopener noreferrer"
              >
                Accéder aux titres
              </Link>
            </React.Fragment>
          )}
        </header>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.security.user,
  isAuth: Boolean(state.security.user)
});

const binActionsToProps = dispatch => ({
  addUser: user => dispatch(addUser(user))
});
export default connect(mapStateToProps, binActionsToProps)(Home);
